export default "__VITE_ASSET__B49gS4Ur__"